import {
  AdminInput,
  AdminRadioInput,
  Button,
  Div,
  Modal,
  P,
  VDriveDeliveryEntity,
  cancelVDriveOrder,
  displayCentsInDollars,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useState } from 'react';

export const DeliveryCancelModal = ({
  isOpen,
  setIsOpen,
  setData,
  setLoading,
  id,
  fee,
  isDriverAssigned,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setData: Dispatch<SetStateAction<VDriveDeliveryEntity | null>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  id: string;
  fee: number;
  isDriverAssigned: boolean;
}) => {
  const [reason, setReason] = useState('');
  const [otherReason, setOtherReason] = useState('');

  async function cancelVDrive() {
    const body = { reason: reason === 'Other' ? otherReason : reason };
    try {
      setLoading(true);
      const { data } = await cancelVDriveOrder(id, body.reason);
      setData(data.data);
      setIsOpen(false);
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {
        setIsOpen(false);
      }}
      header="Cancel Delivery"
      logo={false}
      footer={
        <Button $selected $w="100%" $mt="24" onClick={cancelVDrive}>
          Confirm
        </Button>
      }
      $numOfFloatingButtons={1}
    >
      <P $mb="20" $left>
        Are you sure you want to cancel this delivery?
        {!isDriverAssigned
          ? ` A processing fee of ${displayCentsInDollars(fee)} `
          : ` A driver is already assigned. The full delivery fee of ${displayCentsInDollars(
              fee
            )} `}
        has already been deducted and is non-refundable.
      </P>

      <Div $mb="20">
        {orderCancellationReasons.map((v, i) => (
          <Div $flex $alignCenter key={i}>
            <AdminRadioInput
              label={v}
              onClick={() => setReason(v)}
              checked={v === reason}
            />
          </Div>
        ))}

        {reason === 'Other' && (
          <AdminInput
            type="textarea"
            value={otherReason}
            onChange={({ target }: { target: HTMLTextAreaElement }) =>
              setOtherReason(target.value)
            }
            placeholder="Enter reason"
            label="Other"
            style={{ minHeight: 100, maxHeight: 100 }}
            $textCenter
          />
        )}
      </Div>
    </Modal>
  );
};

const orderCancellationReasons = [
  'Duplicate Order',
  'Out of Zone',
  'Customer Cancelled',
  'Customer Unreachable',
  'Customer Order Changed',
  'Customer Refused Order',
  'Customer Other',
  'Driver Missed Pickup',
  'Merchant Other',
  'Order Not Ready',
  'Order Damaged',
  'Wrong Transportation Type',
  'Driver Failure',
  'No Available Drivers',
  'Other',
];
